import styles from "./BrandStripeChrome.module.css";
import { ReactComponent as LogoSymbol } from "../../assets/media/symbol-fire.svg";

/**
 * Shared brand chrome: angled accent-2 stripe field + dual fire SVGs.
 * Used under Music Catalog titles and NoticeOne / About arch plates.
 *
 * Parent should be `position: relative` (and `overflow: hidden` to clip to a shape).
 * Does not set border, border-radius, or outer plate chrome; those stay on the parent.
 *
 * @param {{ className?: string }} props
 */
const BrandStripeChrome = ({ className = "" }) => {
  return (
    <div
      className={`${styles.root}${className ? ` ${className}` : ""}`}
      aria-hidden="true"
    >
      <div className={styles.stripes} />
      <div className={`${styles.decoration} ${styles.decorationLeft}`}>
        <LogoSymbol />
      </div>
      <div className={`${styles.decoration} ${styles.decorationRight}`}>
        <LogoSymbol />
      </div>
    </div>
  );
};

export default BrandStripeChrome;
